import { i18next } from '@yola/ws-sdk';

const createAnchorValidator = () => (value) => {
  if (!value) {
    return i18next.t('Please select some block');
  }

  return null;
};

export default createAnchorValidator;
